module.exports = __webpack_public_path__ + "img/logo-lecordonbleu.760debc5.svg";